function DropDownIcon({ color, opacity = 0.2 }) {
    return (
        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="18" height="18" rx="9" fill="#587A4D" fillOpacity="0.1" />
            <path
                d="M6.44999 7L8.99999 9.47467L11.55 7L12.3333 7.76533L8.99999 11L5.66666 7.76533L6.44999 7Z"
                fill="#587A4D"
            />
        </svg>
    );
}

export default DropDownIcon;
